import { DerivedData, DerivedOption } from "../interfaces/classifier";

// `item` stays `any`: the two call sites feed different shapes into it — the
// derived search endpoint (typed `OptionType`) and raw categorization-event
// response JSON — and the body reads `label`/`value` off both before storing
// the whole item as `derivedData`. Neither `DerivedData` nor `OptionType`
// describes that union, so a narrower type here would be a guess.
export const mapToDerivedOption = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  item: any,
  categorizationId: string,
  index: number,
): DerivedOption => {
  return {
    key: `derived-${categorizationId}-${index}`,
    value: item.label || item.value,
    label: item.label || item.value,
    visibleValue: item.label || item.value,
    derivedData: item,
  };
};

export const createDerivedOptionsFromResponse = (
  // See `mapToDerivedOption` for why the item type stays `any`.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  items: any[],
  categorizationId: string,
): DerivedOption[] => {
  return items.map((item, index) =>
    mapToDerivedOption(item, categorizationId, index),
  );
};

export const hasDerivedExternalId = (option: DerivedOption): boolean => {
  return !!(option.key && !option.key.startsWith("derived-"));
};

export const prepareDerivedDataForUpsert = (
  derivedData: DerivedData,
): Omit<DerivedData, "label"> => {
  // Strip out label field before sending to upsert - backend generates it
  const { label, ...dataToUpsert } = derivedData;
  return dataToUpsert;
};
